class SamtBackToTop extends HTMLElement {
  connectedCallback() {
    this.render()
    this.bindEvents()
  }

  disconnectedCallback() {
    if (this._onScroll) {
      window.removeEventListener('scroll', this._onScroll)
    }
  }

  render() {
    this.innerHTML = `
      <button
        type="button"
        aria-label="返回顶部"
        class="back-to-top pointer-events-none fixed bottom-4 right-4 z-40 inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/80 text-samt-blue shadow-lg ring-1 ring-black/10 opacity-0 translate-y-2 backdrop-blur transition-all duration-300 hover:bg-white active:scale-95 lg:hidden"
      >
        <span aria-hidden>↑</span>
      </button>
    `
  }

  bindEvents() {
    const button = this.querySelector('.back-to-top')
    if (!button) return

    const toggle = () => {
      const shouldShow = window.scrollY > 200
      button.classList.toggle('opacity-0', !shouldShow)
      button.classList.toggle('translate-y-2', !shouldShow)
      button.classList.toggle('pointer-events-none', !shouldShow)
    }

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })

    this._onScroll = toggle
    toggle()
    window.addEventListener('scroll', this._onScroll, { passive: true })
  }
}

customElements.define('samt-back-to-top', SamtBackToTop)
